<template>
  <div
    id="ranges"
    class="row"
  >
    <div class="col-12">
      <vuetify-table
          :type="type"
          :headers="headers"
          :api-u-r-l="apiURL"
          :title="currentTitle"
          :query-params="queryParams"
          :readonly="readonly"
          :isBatches="true"
          :refresh="refresh"
        >
          <template v-slot:filters>
            <v-row align="center" justify="center">
              <v-col cols="12" sm="4">
                <v-menu
                  v-model="dateMenu1"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedStart"
                      label="Fecha desde"
                      readonly
                      single-line
                      hide-details
                      v-on="on"
                    />
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      :max="dateMax"
                      v-model="dateStart"
                      @input="dateMenu1 = false"
                    />
                  </v-col>
                  <v-col cols="12" sm="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('one')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
              </v-col>
              <v-col cols="12" sm="4">
                <v-menu
                  v-model="dateMenu2"
                  :close-on-content-click="false"
                  :nudge-right="40"
                  transition="scale-transition"
                  offset-y
                  min-width="290px"
                >
                  <template v-slot:activator="{ on }">
                    <v-text-field
                      :value="computedDateFormattedEnd"
                      label="Fecha hasta"
                      readonly
                      single-line
                      hide-details
                      v-on="on"
                    />
                  </template>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-date-picker
                      :color="themeColor"
                      v-model="dateEnd"
                      :max="dateMax"
                      @input="dateMenu2 = false"
                    />
                  </v-col>
                  <v-col cols="12" style="padding: 0 !important;">
                    <v-btn
                      block
                      :color="themeColor"
                      dark
                      @click="today('two')"
                    >
                      HOY
                    </v-btn>
                  </v-col>
                </v-menu>
              </v-col>
            </v-row>
          </template>
        </vuetify-table>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import moment from 'moment';
import { format, parseISO } from 'date-fns';
import VuetifyTable from '~/components/VuetifyTable';

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('lots') };
  },
  components: {
    VuetifyTable,
  },
  props: {
    enterpriseId: { default: '' },
    id: { default: '' },
  },
  data: () => ({
    currentTitle: 'Lotes de Procesamiento',
    type: '',
    dialog: false,
    toggleStatus: false,
    headers: [
      {
        text: 'RIF',
        value: 'rif',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Razón Social',
        value: 'name',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Nombre Archivo',
        value: 'filename',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Total Archivos',
        value: 'count_total',
        align: 'right',
        sortable: true,
      },
      {
        text: 'Total Asignados',
        value: 'count_assigned',
        align: 'right',
        sortable: true,
      },
      {
        text: 'Total No Asignados',
        value: 'count_reject',
        align: 'right',
        sortable: true,
      },
      {
        text: 'Estado',
        value: 'status',
        align: 'left',
        sortable: true,
      },
      {
        text: 'Fecha Creación',
        value: 'created_at',
        align: 'left',
        sortable: true,
      },
    ],
    name: '',
    readonly: true,
    dateStart: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    dateEnd: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    dateMax: format(parseISO(new Date().toISOString()), 'yyyy-MM-dd'),
    dateMenu1: false,
    dateMenu2: false,
    refresh: true,
  }),
  computed: {
    queryParams() {
      return `&dateStart=${this.dateStart}&dateEnd=${this.dateEnd}`;
    },
    apiURL() {
      return '/api/enterprises/batches';
    },
    title() {
      return 'Lotes';
    },
    computedDateFormattedStart() {
        return this.dateStart ? moment(this.dateStart).format('DD-MM-YYYY') : '';
    },
    computedDateFormattedEnd() {
        return this.dateEnd ? format(parseISO(this.dateEnd), 'dd-MM-yyyy') : '';
    },
    ...mapGetters({
      themeColor: 'theme/themeColor',
    }),
  },
  mounted() {
    this.dateStart = moment(this.dateStart).subtract(7, 'days').format('YYYY-MM-DD');
    /* this.dateStart = this.getFecha();
    this.dateEnd = new Date().toISOString().split('T')[0]; */
  },
  methods: {
    today(menu) {
      if (menu === 'one') {
        this.dateStart = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.dateMenu1 = false;
      } else {
        this.dateEnd = format(parseISO(new Date().toISOString()), 'yyyy-MM-dd');
        this.dateMenu2 = false;
      }
    },
   /*  getFecha() {
      const fecha = new Date();
      fecha.setDate(fecha.getDate() - 7);
      return fecha.toISOString().split('T')[0];
    }, */
  },
};
</script>
